import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminHeaderComp from "../subComponent/AdminHeaderComp";
import AddService from "../subComponent/AddService";
import DisplayService from "../subComponent/DisplayServices";

const Services = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem("invCreator")) {
            navigate("/login-creator");
        }
    }, []);

    return (
        <Box sx={{ height: "100vh", backgroundColor: "#020817" }}>
            <AdminHeaderComp />
            <Box p={2} />
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, 
            justifyContent: "space-evenly", gap: "1.5rem", alignItems: { xs: "center", md: "start" },
            }}>
                <AddService />
                <DisplayService />
            </Box>
        </Box>
    )
}
export default Services;